import { render, staticRenderFns } from "./BolsaTrabajo.vue?vue&type=template&id=d1c4918e"
import script from "./BolsaTrabajo.vue?vue&type=script&lang=js"
export * from "./BolsaTrabajo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports